import { render } from "./modal-sisa-asesmen.vue?vue&type=template&id=570e5e3d&scoped=true"
import script from "./modal-sisa-asesmen.vue?vue&type=script&lang=js"
export * from "./modal-sisa-asesmen.vue?vue&type=script&lang=js"

import "./modal-sisa-asesmen.vue?vue&type=style&index=0&id=570e5e3d&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570e5e3d"]])

export default __exports__